import api from '../client';

/**
 * Service pour les analytics et statistiques
 */
const analyticsService = {
  /**
   * Récupérer les statistiques du dashboard
   * @param {Object} params - Paramètres (startDate, endDate)
   * @returns {Promise} Statistiques globales
   */
  getDashboardStats: async (params = {}) => {
    try {
      const response = await api.get('/analytics/dashboard', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer les statistiques de ventes
   * @param {Object} params - Paramètres (period: day, week, month, year)
   * @returns {Promise} Statistiques de ventes
   */
  getSalesStats: async (params = {}) => {
    try {
      const response = await api.get('/analytics/sales', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer les statistiques des conversations
   * @param {Object} params - Paramètres (startDate, endDate, agentId)
   * @returns {Promise} Statistiques des conversations
   */
  getConversationStats: async (params = {}) => {
    try {
      const response = await api.get('/analytics/conversations', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer les statistiques des agents
   * @param {Object} params - Paramètres (startDate, endDate)
   * @returns {Promise} Statistiques des agents
   */
  getAgentStats: async (params = {}) => {
    try {
      const response = await api.get('/analytics/agents', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer les produits les plus vendus
   * @param {Object} params - Paramètres (limit, startDate, endDate)
   * @returns {Promise} Liste des produits
   */
  getTopProducts: async (params = {}) => {
    try {
      const response = await api.get('/analytics/top-products', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer le taux de conversion
   * @param {Object} params - Paramètres (startDate, endDate)
   * @returns {Promise} Taux de conversion
   */
  getConversionRate: async (params = {}) => {
    try {
      const response = await api.get('/analytics/conversion-rate', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer les revenus par période
   * @param {Object} params - Paramètres (period, startDate, endDate)
   * @returns {Promise} Revenus
   */
  getRevenue: async (params = {}) => {
    try {
      const response = await api.get('/analytics/revenue', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default analyticsService;
